import WeHeader from './busi/we-header.vue'
import WeHeaderView from './busi/we-header-view.vue'
import WeCircular from './busi/we-circular.vue'
import WeCircularView from './busi/we-circular-view.vue'
import WeImage from './busi/we-image.vue'
import WeImageView from './busi/we-image-view.vue'
import WeSeries from './busi/we-series.vue'
import WeSeriesView from './busi/we-series-view.vue'
import WeFooterView from './busi/we-footer-view.vue'
import draggable from 'vuedraggable'
import WeVendorView from './busi/we-vendor-view.vue'
import WeVendor from './busi/we-vendor.vue'
import WeInfo from './busi/we-info.vue'
import WeInfoView from './busi/we-info-view.vue'
import WeServiceOrg from './busi/we-service-org.vue'
import WeServiceOrgView from './busi/we-service-org-view.vue'
import WeExpert from './busi/we-expert.vue'
import WeExpertView from './busi/we-expert-view.vue'
import WeGoods from './busi/we-goods.vue'
import WeGoodsView from './busi/we-goods-view.vue'

export const componentList = {
  WeInfo,
  WeInfoView,
  WeVendorView,
  WeVendor,
  WeCircularView,
  WeHeaderView,
  WeSeriesView,
  WeFooterView,
  WeImageView,
  WeImage,
  WeHeader,
  WeCircular,
  WeSeries,
  draggable,
  WeServiceOrg,
  WeServiceOrgView,
  WeExpert,
  WeExpertView,
  WeGoods,
  WeGoodsView
}
export const actionList = [
  { label: '合作服务', value: 1 },
  { label: '图片导航', value: 2 },
  { label: '轮播图', value: 3 },
  { label: '合作企业', value: 4 },
  { label: '资讯组件', value: 6 },
  { label: '合作机构', value: 8 },
  { label: '产品白名单', value: 9 },
  { label: '人员白名单', value: 10 }
]

export const getSeries = {
  1: () => ({ componentName: 'servicecategoryshow', layoutType: 1, graphics: [], visible: false }), // 合作服务
  2: () => ({ componentName: 'pictureadv', layoutType: 1, graphics: [], visible: false }), // 图片导航
  3: () => ({ componentName: 'pictureadv', layoutType: 0, graphics: [], styleType: 1, visible: false }), // 轮播图
  4: () => ({ componentName: 'vendorshow', layoutType: 1, graphics: [], visible: false }), // 合作企业
  6: () => ({ componentName: 'info', visible: false }), // 资讯组件
  8: () => ({ componentName: 'servorgshow', graphics: [], layoutType: 2, visible: false }), // 合作机构
  9: () => ({ componentName: 'goodsshow', graphics: [], visible: false }), // 产品白名单
  10: () => ({ componentName: 'expertshow', graphics: [], visible: false }) // 人员白名单
}
